const sameArrays = (arr1, arr2) => {
  if (!arr1 || !arr1.length) {
    return !arr2 || !arr2.length;
  }
  if (!arr2 || (arr1.length !== arr2.length)) {
    return false;
  }
  return !arr1.find(o1 => arr2.indexOf(o1) < 0);
};
class FormEditor {
  constructor(property, options) {
    this.name = property.name;
    this.label = property.label;
    this.options = options;
    this.type = property.type;
    this.property = property;
    this.id = (options && options.id) || property.id || `Form${property.type}-${property.name}`;

    this.dependsOn = property.dependsOn;
    this.getValue = (options && options.getValue) || (data => data[this.name]);
    this.setValue = (options && options.setValue) || ((data, value) => { data[this.name] = value; });
  }

  ensureValue(value /* , data, props */) {
    // If enum editor, value might not be listed within enum options
    return value;
  }
}

export { FormEditor as default, sameArrays };
